<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Frontbmatterbheads">Contents</p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c01.htm">Fabric Flowers</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c01.htm#rose">ROSE</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c01.htm#blossom">BLOSSOM</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c01.htm#dahlia">DAHLIA</a></p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c02.htm">Simple Cupped Flower</a></p>
<p class="P_TOCbChapterbtitle"><a class="hlink" href="#/OEBPS/c03.htm">Lifelike Flowers</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c03.htm#poppy">POPPY</a></p>
<p class="P_TOCbmiscbhead"><a class="hlink" href="#/OEBPS/c03.htm#peony">PEONY</a><br/><br/></p>
<div class="Image"><img alt="" src="OEBPS/images/1-1.jpg"/></div>
<p class="P_CAPbimage">Fuchsia Fashionista<br/>Three-dimensional fabric-effect roses, dahlias and blossoms are used to decorate this gorgeous handbag cake that will make any fashion-conscious woman drool!</p>
<p class="CAP">Tip</p>
<p class="CAP">Whether you choose to add simple cut-out flowers or full-sized lifelike blooms will depend on the look you are after and the time you have available.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1d5865ca